import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, toDisplayString as _toDisplayString, Fragment as _Fragment } from "vue"
import _imports_0 from '@/app/ui/assets/svg/arrow-left.svg'


const _hoisted_1 = { class: "\n        py-4\n        flex flex-row\n        justify-start\n        items-center\n        border-b border-gray-lp-400\n      " }
const _hoisted_2 = { class: "font-semibold text-20px mr-4 text-black-lp-200" }
const _hoisted_3 = {
  key: 1,
  class: "flex flex-row py-6 h-full"
}
const _hoisted_4 = { class: "w-2/3 px-4 text-12px xxl:text-14px overflow-y-auto pb-20 space-y-6" }
const _hoisted_5 = /*#__PURE__*/_createVNode("div", { class: "font-semibold text-black-lp-300 text-12px xxl:text-14px" }, " ID Transportasi ", -1)
const _hoisted_6 = { class: "my-1 text-black-lp-300 text-12px xxl:text-14px font-normal" }
const _hoisted_7 = /*#__PURE__*/_createVNode("div", { class: "font-semibold text-black-lp-300 text-12px xxl:text-14px" }, " Kode Transportasi ", -1)
const _hoisted_8 = { class: "my-1 text-black-lp-300 text-12px xxl:text-14px font-normal" }
const _hoisted_9 = /*#__PURE__*/_createVNode("div", { class: "font-semibold text-black-lp-300 text-12px xxl:text-14px" }, " Tipe Transportasi ", -1)
const _hoisted_10 = { class: "my-1 text-black-lp-300 text-12px xxl:text-14px font-normal flex flex-row" }
const _hoisted_11 = { class: "rounded capitalize px-2 py-0 bg-gray-lp-200 mr-2" }
const _hoisted_12 = /*#__PURE__*/_createVNode("div", { class: "font-semibold text-black-lp-300 text-12px xxl:text-14px" }, " Nama Vendor ", -1)
const _hoisted_13 = { class: "my-1 text-black-lp-300 text-12px xxl:text-14px font-normal" }
const _hoisted_14 = /*#__PURE__*/_createVNode("div", { class: "font-semibold text-black-lp-300 text-12px xxl:text-14px" }, " Kode Vendor ", -1)
const _hoisted_15 = { class: "my-1 text-black-lp-300 text-12px xxl:text-14px font-normal" }
const _hoisted_16 = { class: "w-1/3 px-8 text-12px xxl:text-14px border-l border-gray-lp-400" }
const _hoisted_17 = { class: "py-3" }
const _hoisted_18 = /*#__PURE__*/_createVNode("div", { class: "font-semibold text-black-lp-300 text-12px xxl:text-14px" }, " Status Transportasi ", -1)
const _hoisted_19 = { class: "my-1 text-black-lp-300 text-12px xxl:text-14px font-normal" }
const _hoisted_20 = { class: "flex" }
const _hoisted_21 = { class: "capitalize" }
const _hoisted_22 = { class: "py-3" }
const _hoisted_23 = /*#__PURE__*/_createVNode("div", { class: "font-semibold text-black-lp-300 text-12px xxl:text-14px" }, " Tanggal Dibuat ", -1)
const _hoisted_24 = { class: "my-1 text-black-lp-300 text-12px xxl:text-14px font-normal" }
const _hoisted_25 = { class: "text-gray-lp-500" }
const _hoisted_26 = { class: "py-3" }
const _hoisted_27 = /*#__PURE__*/_createVNode("div", { class: "font-semibold text-black-lp-300 text-12px xxl:text-14px" }, " Tanggal Diubah ", -1)
const _hoisted_28 = { class: "my-1 text-black-lp-300 text-12px xxl:text-14px font-normal" }
const _hoisted_29 = { class: "text-gray-lp-500" }
const _hoisted_30 = { class: "py-3 inline-flex" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_PageDetailLazyLoad = _resolveComponent("PageDetailLazyLoad")!
  const _component_ErrorMessage = _resolveComponent("ErrorMessage")!
  const _component_button_fill = _resolveComponent("button-fill")!

  return (_ctx.isLoading)
    ? (_openBlock(), _createBlock(_component_PageDetailLazyLoad, {
        key: 0,
        onBack: _ctx.goBack
      }, null, 8, ["onBack"]))
    : (_openBlock(), _createBlock(_Fragment, { key: 1 }, [
        _createVNode("div", _hoisted_1, [
          _createVNode("img", {
            src: _imports_0,
            onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.goBack && _ctx.goBack(...args))),
            class: "w-5 mr-3 cursor-pointer",
            alt: "arrow-left"
          }),
          _createVNode("div", _hoisted_2, _toDisplayString(_ctx.dataDetail.transportCode), 1)
        ]),
        (_ctx.isError)
          ? (_openBlock(), _createBlock(_component_ErrorMessage, {
              key: 0,
              errorType: _ctx.errorCause,
              onTryAgain: _ctx.fetchTransportData
            }, null, 8, ["errorType", "onTryAgain"]))
          : (_openBlock(), _createBlock("div", _hoisted_3, [
              _createVNode("div", _hoisted_4, [
                _createVNode("div", null, [
                  _hoisted_5,
                  _createVNode("div", _hoisted_6, _toDisplayString(_ctx.dataDetail.id), 1)
                ]),
                _createVNode("div", null, [
                  _hoisted_7,
                  _createVNode("div", _hoisted_8, _toDisplayString(_ctx.dataDetail.transportCode), 1)
                ]),
                _createVNode("div", null, [
                  _hoisted_9,
                  _createVNode("div", _hoisted_10, [
                    _createVNode("div", _hoisted_11, _toDisplayString(_ctx.dataDetail.transportType), 1)
                  ])
                ]),
                _createVNode("div", null, [
                  _hoisted_12,
                  _createVNode("div", _hoisted_13, _toDisplayString(_ctx.dataDetail.vendorName), 1)
                ]),
                _createVNode("div", null, [
                  _hoisted_14,
                  _createVNode("div", _hoisted_15, _toDisplayString(_ctx.dataDetail.vendorCode), 1)
                ])
              ]),
              _createVNode("div", _hoisted_16, [
                _createVNode("div", _hoisted_17, [
                  _hoisted_18,
                  _createVNode("div", _hoisted_19, [
                    _createVNode("div", _hoisted_20, [
                      _createVNode("div", {
                        class: 
                  `rounded-full px-2 py-0 font-medium ${
                    _ctx.dataDetail.status.toLowerCase() === 'active'
                      ? 'bg-green-lp-300'
                      : 'bg-red-lp-600'
                  } ${
                    _ctx.dataDetail.status.toLowerCase() === 'active'
                      ? 'text-green-lp-200'
                      : 'text-red-lp-500'
                  }`
                
                      }, [
                        _createVNode("span", _hoisted_21, _toDisplayString(_ctx.dataDetail.status.toLowerCase()), 1)
                      ], 2)
                    ])
                  ])
                ]),
                _createVNode("div", _hoisted_22, [
                  _hoisted_23,
                  _createVNode("div", _hoisted_24, _toDisplayString(_ctx.createdAt), 1),
                  _createVNode("div", _hoisted_25, _toDisplayString(_ctx.dataDetail.createdBy), 1)
                ]),
                _createVNode("div", _hoisted_26, [
                  _hoisted_27,
                  _createVNode("div", _hoisted_28, _toDisplayString(_ctx.updatedAt), 1),
                  _createVNode("div", _hoisted_29, _toDisplayString(_ctx.dataDetail.updatedBy), 1)
                ]),
                _createVNode("div", _hoisted_30, [
                  (_ctx.isEditAble)
                    ? (_openBlock(), _createBlock(_component_button_fill, {
                        key: 0,
                        title: "Ubah",
                        onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.goEdit(_ctx.$route.params.id))),
                        class: "px-8 bg-red-lp-300"
                      }))
                    : _createCommentVNode("", true)
                ])
              ])
            ]))
      ], 64))
}